import { TicketPriceDTO } from "../TicketPriceDTO";
import { TicketsGroupDTO } from "../tickets/TicketsGroupDTO";

export class TicketMinDTO {
  id: number;
  isActive: boolean;
  title: string;
  summary: string;
  saleDateFrom: string;
  saleDateTo: string;
  startEvent?: string;
  endEvent?: string | null;
  images: any[] = [];
  prices: TicketPriceDTO[] = [];
  eventId?: number;
  eventName: string;
  eventDateFrom?: Date;
  eventDateTo?: Date;
  eventImage: string;
  ticketsGroups?: TicketsGroupDTO[];
  categoryId?: number;
  categoryName: string;
  categoryColor: string;
  isOpened: boolean;
}
